<template>
    <el-dialog
      title=""
      :visible.sync="$store.state.promotionObj.groupFalg"
      width="90%"
      :append-to-body="true"
      :close-on-click-modal="false"
      center>
        <div class="tabs-container ng-scope">
          
          <div class="ibox-content m-b-sm border-bottom">
            <div class="row form-horizontal">
              <div class="form-group  margin-0">
                <label class="col-sm-2 control-label">Promotion</label>
                <div class="col-sm-8">
                  <div>
                    <el-input
                      v-model="searchName"
                      name="search"
                    ></el-input>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class>
                    <el-button type="primary" @click="search">{{$t("message.Search") }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="ibox float-e-margins">
                <div class="ibox-content">
                  <div class="row table-responsive" style="padding-bottom:60px;">
                    <div class="col-xs-12">{{rows.length}}{{$t("message.datagridresult") }}</div>
                    <el-table :data="rows" style="width: 100%" border ref="multipleTable" @selection-change="handleSelectionChange" @sort-change="sortChange" @row-dblclick="handleDbClick">
                      <el-table-column type="selection" width="55" ></el-table-column>
                      <el-table-column
                        prop="title"
                        :show-overflow-tooltip="true"
                        label="Title"
                      ></el-table-column>
                    </el-table>
                    <el-col :span="24" class="el-table_footertoolbar">
                      <el-pagination 
                         layout="total, sizes, prev, pager, next, jumper" 
                         @size-change="handleSizeChange" 
                         @current-change="handleCurrentChange" 
                         :page-sizes="[10, 20, 50, 100]" 
                         :page-size="pagesize" 
                         :total="total" 
                         style="float:right;">
                      </el-pagination>
                    </el-col>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.state.promotionObj.groupFalg = false">Cancel</el-button>
        <el-button type="primary" @click="addEvent">Confirm</el-button>
      </span>
    </el-dialog>
</template>
<script>
import config from "../../config";
export default {
  name: "groupDlgController",
  mixins: [config.globalMixin],
  data() {
    return {
      page: 0,//当前页数
      pagesize:10,//一页显示几条
      sortType:"DESC",
      sortField:"id",
      searchName: "",
      eventTypes:"",
      status:0,
      total:0,
      rows:[],
      multipleSelection:[],
      eventTypeObj:[],
      statusObj:[],
      internetContentCode:""
    };
  },
  methods: {
    cancel: function() {
      this.$store.commit("seteventlist", { string: "", boolean: false });
    },
    async init() {
      let obj = this.getAuthObj();
      obj.pageIndex = this.page;
      obj.pageSize = this.pagesize;
      obj.title = this.searchName;
      obj.status = this.ACTIVE_STATUS;
      obj.sortName = this.sortField;
      obj.sortType = this.sortType;
      obj.name = this.searchName;
      if(this.$store.state.promotionObj.type===0){
        obj.apiUrl = this.apiConfig.imgbannerList;
        obj.status = 1;
      }else if(this.$store.state.promotionObj.type==1){
        obj.apiUrl = this.apiConfig.publicityList;
        obj.parentId = -1
      }else if(this.$store.state.promotionObj.type==2){
        obj.apiUrl = this.apiConfig.eventList;
      }else if(this.$store.state.promotionObj.type==3){
        obj.apiUrl = this.apiConfig.eLearningSubList;
      }
      let data = await this.$store.dispatch("apiEvent", obj);
      if(!data) return;
      let list = null;
      if(this.$store.state.promotionObj.type===0){
        this.rows = data.data.result.imgBanners;
      }else if(this.$store.state.promotionObj.type==1){
        this.rows = data.data.result.publicityList;
      }else if(this.$store.state.promotionObj.type==2){
        this.rows = data.data.result.events;
      }else if(this.$store.state.promotionObj.type==3){
        this.rows = data.data.result['e-learning'];
      }
      
      this.total = data.data.result.total;
    },
    search() {
      this.page = 1
      this.init();
    },
    handleSizeChange:function(val){
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange:function(val){
      this.page = val;
      this.init();
    },
    handleSelectionChange:function(val){
      this.multipleSelection = val;
    },
    handleDbClick:function(row){
      // this.$router.push({
      //   path: "/main/eventGroupDetail",
      //   query: { id: row.id }
      // });
    },
    sortChange:function(val){
      if(val.order=='ascending'){
        this.sortType = 'ASC';
        this.sortField = val.prop;
      }else if(val.order=="descending"){
        this.sortType = 'DESC';
        this.sortField = val.prop;
      }else{
        this.sortType = 'ASC';
        this.sortField = 'id';
      }
      this.init();
    },
    addEvent:function(){
      this.$store.state.promotionObj.callback(this.multipleSelection)
    }
  },
  computed:{
      _obj(){
        return this.$store.state.promotionObj.groupFalg
      }
  },
  watch: {
    _obj:function(){
      if(this.$store.state.promotionObj.groupFalg){
        this.init();
      }
    }
  },
  mounted() {
    // this.init();
  },
};
</script>
